import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { useUserState } from 'contexts/auth-context';
import t from 'utils/translateFunc';

import { Icon } from '../../Elements';

import { textToDateOrTime } from 'utils/common';

import classes from './FavoriteWidget.module.scss';

const FavoriteWidget = ({ dataFavorite, mode = 'maxAudience' }) => {
  const language = useUserState().user.language;

  return (
    <div className={classes.favoriteWidget}>
      <div
        className={cn(
          classes.titleBox,
          mode === 'maxAudience' && classes.titleBox_purple,
          mode === 'maxViews' && classes.titleBox_pink
        )}
      >
        <h2 className={classes.title}>
          {t('favoriteWidget', 'RELEASES', language)}
        </h2>
        <h3 className={classes.discription}>
          {mode === 'maxAudience'
            ? t('favoriteWidget', 'MAX_AUDIENCE', language)
            : t('favoriteWidget', 'MAX_COUNT_OUTPUTS', language)}
        </h3>
      </div>
      <ul className={classes.favoriteList}>
        {dataFavorite.map((favorite, index) => (
          <Fragment key={favorite.id}>
            {index < 3 && (
              <li className={classes.favoriteItem}>
                <p className={classes.number}>{index + 1}</p>
                <div>
                  <div className={classes.wrapHeading}>
                    <Link
                      className={cn(classes.link, classes.hiddenTextThree)}
                      to={`/groups/${favorite.id}`}
                    >
                      {favorite.articleTitle}
                    </Link>
                  </div>
                  <p className={classes.wrapInfo}>
                    <span>
                      {textToDateOrTime(favorite.createdDate, 'date')}
                    </span>
                    <span className={classes.time}>
                      {textToDateOrTime(favorite.createdDate, 'time')}
                    </span>
                    {mode === 'maxAudience' && (
                      <Icon
                        icon={'Icn_Audience-1'}
                        className={classes.iconFavorite}
                      />
                    )}
                    {mode === 'maxViews' && (
                      <Icon
                        icon={'Icn_Copies'}
                        className={classes.iconFavorite}
                      />
                    )}
                    <span>
                      {mode === 'maxAudience'
                        ? favorite.totalAverageAttendance
                        : favorite.articlesLen}
                    </span>
                  </p>
                </div>
              </li>
            )}
          </Fragment>
        ))}
      </ul>
    </div>
  );
};

FavoriteWidget.propTypes = {
  dataFavorite: PropTypes.array,
  mode: PropTypes.string.isRequired
};

export default FavoriteWidget;
